module.exports = __webpack_public_path__ + "img/brands-mobit.c3443e4d.svg";